import { Dimensions } from 'react-native';

export const vw = Dimensions.get('window').width;
export const vh = Dimensions.get('window').height;
export const vmin = Math.min(vw, vh);
export const vmax = Math.max(vw, vh);

const TRAIN_WIDTH_ORIGINAL = 200;
const TRAIN_HEIGHT_ORIGINAL = 105;
export const TRAIN_WIDTH = vw / 10;
export const TRAIN_HEIGHT =
	(TRAIN_HEIGHT_ORIGINAL * TRAIN_WIDTH) / TRAIN_WIDTH_ORIGINAL;
